
import { defineComponent, ref, Transition } from "vue";
import { api } from "@/services/Api";
import swal from "sweetalert2";
import { useI18n } from "vue-i18n";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import q from "q";
import CheckBoxInput from "@/components/CheckBoxInput.vue";
import { useStore } from "@/store";
import { isElectron } from '@/utils/electron';
import OverlayModal from "./OverlayModal.vue";
import { setItem, LOCAL_STATION_DATA_KEY_PREFIX, getStationDataFromStorage } from "@/utils/localStorage";
import { StationData } from "@/models/Shift";

const rememberMeLocalStorageKey = "cashier_rememberMe";

export default defineComponent({
  components: { LanguageSwitcher, CheckBoxInput, OverlayModal, Transition },
  async beforeRouteEnter(to, from, next) {
    var rememberMeValue = localStorage.getItem(rememberMeLocalStorageKey);
    if (rememberMeValue) {
      const loginData = JSON.parse(rememberMeValue);

      const stationData = getStationDataFromStorage();
      if(!stationData) return;

      const response = await api.login(loginData.username, loginData.password, stationData.cashierGuid);
      if (response.errorMessage) {
        next();
        return;
      }
      window.location.assign("");
      return;
    }
    next();
  },
  async setup() {
    const { t } = useI18n();
    const username = ref("");
    const password = ref("");
    const inputType = ref("password");
    const rememberMe = ref(false);
    const openStorageModal = ref(false);
    const cashierGuid = ref("");
    const stationData = ref<StationData>({cashierGuid: ""});
    const store = useStore();
    

    function switchVisibility() {
      inputType.value = inputType.value == "password" ? "text" : "password";
    }

    async function login() {
      if (!username.value.trim() || !password.value.trim()) {
        swal.fire({
          icon: "error",
          text: t("cashier.login.empty-fields"),
        });
        return;
      }
      swal.showLoading();

      const stationData = getStationDataFromStorage();
      if(!stationData) return;

      const responsePromise = api.login(username.value, password.value, stationData.cashierGuid, store.state.lang);
      await q.delay(400);
      const response = await responsePromise;
      if (response.errorMessage) {
        swal.fire({
          icon: "error",
          title: t("error-pop-up.oops"),
          text: response.errorMessage,
        });
        return;
      }
      if (rememberMe.value) {
        localStorage.setItem(
          rememberMeLocalStorageKey,
          JSON.stringify({ username: username.value, password: password.value })
        );
      }
      window.location.assign("");
    }

    async function closeApplication() {
      await api.closeApplication();
    }

    function saveStationDataInLocalStorage(){
      if (!stationData.value.cashierGuid.trim()) {
        swal.fire({
          icon: "error",
          text: t('cashier.shift.stationDataFieldsRequired'),
        });
        return;
      }

      setItem(LOCAL_STATION_DATA_KEY_PREFIX, JSON.stringify(stationData.value));
      openStorageModal.value = false;
    }

    return {
      t,
      username,
      password,
      login,
      closeApplication,
      inputType,
      switchVisibility,
      rememberMe,
      isElectron,
      openStorageModal,
      cashierGuid,
      saveStationDataInLocalStorage,
      stationData
    };
  },
});
